function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1121",
  "data-name": "Group 1121",
  transform: "translate(-143.097 -505.097)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1069",
  "data-name": "Group 1069",
  transform: "translate(-117 272)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_741",
  "data-name": "Group 741",
  transform: "translate(265 234)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_676",
  "data-name": "Path 676",
  d: "M70.435,63.5H7.826A7.631,7.631,0,0,1,0,55.935V21.761a7.686,7.686,0,0,1,7.826-7.826H28.7a2.26,2.26,0,0,0,1.826-1.043L32.348,6.63A4.465,4.465,0,0,1,36.522,3.5H54.783a4.8,4.8,0,0,1,4.435,3.13l1.826,6.261a1.43,1.43,0,0,0,1.565,1.043h7.826a7.686,7.686,0,0,1,7.826,7.826V55.935A7.8,7.8,0,0,1,70.435,63.5ZM7.826,16.543a5.233,5.233,0,0,0-5.217,5.217V55.935a5.016,5.016,0,0,0,5.217,4.957H70.435a5.186,5.186,0,0,0,5.217-4.957V21.761a5.233,5.233,0,0,0-5.217-5.217H62.609a4.232,4.232,0,0,1-4.174-2.87L56.609,7.413a1.962,1.962,0,0,0-1.826-1.3H36.522a1.962,1.962,0,0,0-1.826,1.3L32.87,13.674a4.02,4.02,0,0,1-4.174,2.87Z",
  transform: "translate(0 -3.5)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_742",
  "data-name": "Group 742",
  transform: "translate(272.826 236.609)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_677",
  "data-name": "Path 677",
  d: "M9.522,7.109H4.3A1.232,1.232,0,0,1,3,5.8,1.232,1.232,0,0,1,4.3,4.5H9.522a1.232,1.232,0,0,1,1.3,1.3A1.232,1.232,0,0,1,9.522,7.109Z",
  transform: "translate(-3 -4.5)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_743",
  "data-name": "Group 743",
  transform: "translate(272.826 252.261)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_678",
  "data-name": "Path 678",
  d: "M9.522,13.109H4.3A1.232,1.232,0,0,1,3,11.8a1.232,1.232,0,0,1,1.3-1.3H9.522a1.232,1.232,0,0,1,1.3,1.3A1.232,1.232,0,0,1,9.522,13.109Z",
  transform: "translate(-3 -10.5)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_744",
  "data-name": "Group 744",
  transform: "translate(298.913 257.478)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_679",
  "data-name": "Path 679",
  d: "M24.739,35.978A11.739,11.739,0,1,1,36.478,24.239,11.69,11.69,0,0,1,24.739,35.978Zm0-20.87a9.13,9.13,0,1,0,9.13,9.13A9.243,9.243,0,0,0,24.739,15.109Z",
  transform: "translate(-13 -12.5)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_745",
  "data-name": "Group 745",
  transform: "translate(291.087 249.652)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_680",
  "data-name": "Path 680",
  d: "M29.565,48.63A19.565,19.565,0,1,1,49.13,29.065,19.708,19.708,0,0,1,29.565,48.63Zm0-36.522A16.957,16.957,0,1,0,46.522,29.065,16.923,16.923,0,0,0,29.565,12.109Z",
  transform: "translate(-10 -9.5)",
  fill: "#d5d5d5"
}))), /*#__PURE__*/React.createElement("line", {
  id: "Line_69",
  "data-name": "Line 69",
  y1: 61,
  x2: 79,
  transform: "translate(147.5 508.5)",
  fill: "none",
  stroke: "#d5d5d5",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_70",
  "data-name": "Line 70",
  y1: 61.772,
  x2: 80,
  transform: "translate(144.5 506.5)",
  fill: "none",
  stroke: "#f5f5f5",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_71",
  "data-name": "Line 71",
  y1: 61.772,
  x2: 80,
  transform: "translate(148.5 510.5)",
  fill: "none",
  stroke: "#f5f5f5",
  strokeLinecap: "round",
  strokeWidth: 2
}));

var SvgNoImage = function SvgNoImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86.805,
    height: 68.578,
    viewBox: "0 0 86.805 68.578",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-image.ca7f73c4.svg";
export { ForwardRef as ReactComponent };